class Layout {

    constructor() {
        /* Configuration */

        /* Unique APP Selectors */
        this.html       = $('html');
        this.body       = $('body');
        this.main       = document.querySelector('main');
        this.footer     = $('footer');
        this.ready      = false;

        this.settings   = {
            refresh:    {
                id:     null,
                time:   100,
            }
        };

        /* Wait for last CSS file to be loaded and content to be shown */
        if (this.main) {
            const interval = App.setInterval(() => {
                /* Important! Change statement if style changes */
                if (getComputedStyle(this.main).display !== 'none') {
                    clearInterval(interval);
                    this.ready = true;
                    this.prepare();
                }
            });
        }

        // keep track of overlay components and interfaces
        this.normalizer = [];
    }

    get container() {
        return document.getElementById('content') || this.main;
    }

    get top() {
        return (document.querySelector('header')?.offsetHeight || 0) + 15;
    }

    prepare() {
        this.bind();
    }

    setResourcesFromPage(Page) {
        const promises = [
            this.setFMPResources(Page),
            this.setFCPResources(Page),
        ];
        return Promise.all(promises);
    }

    async setFMPResources(Page, overlay = 'page') {
        // Set CSS from all groups
        for (let key in Page.cssResources) {
            for (let k in Page.cssResources[key]) {
                await App.Page.getStyle(Page.cssResources[key][k], '', '', overlay);
            }
        }
    }

    async setFCPResources(Page, overlay = 'page') {
        // JS
        for (let key in Page.jsResources) {
            await App.Page.getScript(Page.jsResources[key], '', '', overlay);
        }
    }

    async load(page = App.Entities.Page, normalize = true) {
        // Clear cache
        App.Page
            .removeResources()
            .pushPage(page)
        ;
        await this.setFMPResources(page);
        this
            .setTitle(page.title)
            .setContent(page.content)
        ;
        await this.setFCPResources(page);
        this.refresh();
        App.Observer.notify();
        if (normalize) {
            this.setPosition(page.position);
            App.Components.Popup.hide(true);
        }
        window.gaTrackView();
        return this;
    }

    setContent(content) {
        this.container.innerHTML = content;
        return this;
    }

    setPosition(position, transition = true) {
        if (transition) {
            window.scroll({
                top:        position,
                left:       0,
                behavior:   'smooth',
            });
        } else {
            window.scrollTo(0, position);
        }
    }

    /**
     * Refresh DOM looking for new Html Elements
     *
     * @return
     */
    refresh() {
        let Self = this;
        if (this.settings.refresh.id !== null) {
            clearTimeout(this.settings.refresh.id);
        }
        this.settings.refresh.id = setTimeout(function() {
            $(document).triggerHandler('ajaxComplete');
            Self.settings.refresh.id = null;
        }, this.settings.refresh.time);
        return this;
    }

    /**
     * Change Page title
     * Change window title
     *
     * @return
     */
    setTitle(title) {
        document.title = title;
        return this;
    }

    /**
     * Change App Brand
     *
     * @return
     */
    setBrand(brand) {
        if (brand) {
            this.body.data('brand', brand);
            this.body.attr('data-brand', brand);
        } else {
            this.body.data('brand', 'mymuesli');
            this.body.attr('data-brand', 'mymuesli');
        }
        return this;
    }

    /**
     * use this to stop scrolling page on mobile devices
     * if we are using an overlay like menu or search
     *
     * @param active
     */
    fullOverlay (active = true) {
        let className = 'full-overlay';
        if (active) {
            this.position = $(window).scrollTop();
            this.html.addClass(className);
        } else {
            this.html.removeClass(className);
            this.setPosition(this.position, false);
            this.position = 0;
        }
    }

    /* Define if window scrolls */
    scroll(scroll = true) {
        // For Browsers (Scroll)
        if (scroll) {
            this.html.removeClass('do-not-scroll');
        } else {
            this.html.addClass('do-not-scroll');
        }
    }

    normalize() {
        this.normalizer.forEach(fn => fn());
        return this;
    }

    onNormalize(callback) {
        this.normalizer.push(callback);
        return this;
    }

    /**
     * Set a min page size, leaving the footer slightly visible
     *
     * @return
     */
    fitWindowSize() {
        App.wait('App.Layout.Header', Header => {
            var height = $(window).height() - $(Header.container).outerHeight(true) - 100;
            $(this.main).css('min-height', height);
        });
        return this;
    }

    bind() {
        window.addEventListener('focus', event => {
            App.Observer.notify();
        }, false);
    }

    isElementInViewport(element) {
        const rect = element.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    count(obj, duration, start = 0) {
        // If there's no number, abort
        if (!/\d/.test( obj.innerText)) {
            return;
        }

        let startTimestamp = null;
        // Store initial numbers
        const nums = obj.innerText.split(new RegExp('(\\d+)', 'g'));

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            // Get numbers of the current loop
            const newNums = obj.innerText.split(new RegExp('(\\d+)', 'g'));

            // Replace all numbers with the current loop's calculation
            newNums.forEach((num, i) => {
                if (/\d/.test(num)) {
                    num = parseInt(num, 10);
                    // If the initial number is higher than the starting number, count down
                    // Otherwise count up
                    const direction = nums[i] > start ? start + nums[i] : nums[i] - start;
                    // Replace numbers on their correct place in the string
                    newNums[i] = Math.floor(progress * direction + start);
                    obj.innerText = newNums.join(' ');
                }
            });

            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };

        window.requestAnimationFrame(step);
    }
}

App.Layout = new Layout();
